import SubLayout from "@/components/SubLayout";
import { Tabs } from "antd-mobile";
import { useState } from "react";
import { BuyerTable, RiskTable, SellerTable } from "./data";
import styles from "./index.module.scss";
const waitingSellerCompleteOrderStr = "15分钟";
export const PagePanic = () => {
  const [activeKey, setActiveKey] = useState<string>("buyer");
  return <SubLayout title={"异常交易行为以及平台处理措施"} footer={<div className={styles.footer}>
          注：本规则涉及卖方退款或放行，而卖家未按时完成操作的，系统将限制卖方账户部分功能
        </div>} data-sentry-element="SubLayout" data-sentry-component="PagePanic" data-sentry-source-file="index.tsx">
      <div className={styles.wrapper}>
        <section className={styles.tabs}>
          <Tabs activeKey={activeKey} onChange={setActiveKey} data-sentry-element="Tabs" data-sentry-source-file="index.tsx">
            <Tabs.Tab key={"buyer"} title={"买方异常"} data-sentry-element="unknown" data-sentry-source-file="index.tsx" />

            <Tabs.Tab key={"seller"} title={"卖方异常"} data-sentry-element="unknown" data-sentry-source-file="index.tsx" />

            <Tabs.Tab key={"risk"} title={"风险异常"} data-sentry-element="unknown" data-sentry-source-file="index.tsx" />
          </Tabs>
        </section>
        <section className={styles.content}>
          {activeKey === "buyer" ? <BuyerTable waitingSellerCompleteOrderStr={waitingSellerCompleteOrderStr} /> : null}
          {activeKey === "seller" ? <SellerTable /> : null}
          {activeKey === "risk" ? <RiskTable /> : null}
        </section>
      </div>
    </SubLayout>;
};